<script lang="ts">
  import type { ShellController } from './shell-controller.svelte';
  import { features } from '../../features/feature-state.svelte';
  import { SHIP_CUSTOMIZATION } from '../../features/overrides';

  const { shell }: { shell: ShellController } = $props();

  const credit = $derived(shell.profile?.credit ?? 0);
</script>

{#if shell.loggedIn}
  <div class="wis-panel wis-panel--corner corner--in">
    <div class="wis-row corner__who">
      <span class="corner__rank">Commander</span>
      <span class="corner__white corner__name"
        >{shell.profile?.username ?? shell.sessionUsername}</span
      >
      <span class="corner__white corner__credits" data-testid="corner-credits"
        >{credit} credits</span
      >
    </div>
    <button
      id="frontScreenShopBtn"
      class="wis-btn-inline corner__shop"
      type="button"
      onclick={() => {
        shell.navigate('shop');
      }}>Shop</button
    >
    {#if features.enabled(SHIP_CUSTOMIZATION)}
      <button
        class="wis-btn-inline corner__loadout"
        type="button"
        data-testid="corner-loadout"
        onclick={() => {
          shell.navigate('loadout');
        }}>Loadout</button
      >
    {/if}
    <button
      class="wis-btn-inline corner__logout"
      type="button"
      onclick={() => {
        void shell.logout();
      }}>Logout</button
    >
  </div>
{:else}
  <div class="wis-panel wis-panel--corner corner--out">
    <button
      id="nav-login"
      class="wis-btn-inline corner__login"
      type="button"
      onclick={() => {
        shell.navigate('login');
      }}>Login</button
    >
    <button
      class="wis-btn-inline corner__register"
      type="button"
      onclick={() => {
        shell.navigate('register');
      }}>Register</button
    >
    <a class="wis-row corner__terms" href="/legal/terms.html">Terms and Conditions</a>
    <a class="wis-row corner__privacy" href="/legal/privacy.html">Privacy Policy</a>
  </div>
{/if}

<style>
  .corner--out {
    width: 265px;
    height: 236px;
  }

  .corner--in {
    width: 300px;
    height: 267px;
  }

  /*
   * No width/height here on purpose: these size intrinsically from content + wis-btn-inline's
   * padding, as the original does. Pinning a width/height does not reproduce that size, and
   * would also expose the padding to the global border-box reset.
   */
  .corner__login {
    position: absolute;
    top: 100px;
    left: 15px;
  }

  .corner__register {
    position: absolute;
    top: 100px;
    left: 121px;
  }

  .corner__terms,
  .corner__privacy {
    font-size: 10px;
    color: #10245e;
    text-decoration: underline;
  }

  .corner__terms:hover,
  .corner__privacy:hover {
    color: #000;
  }

  .corner__terms {
    top: 152px;
  }

  .corner__privacy {
    top: 171px;
  }

  .corner__who {
    top: 106px;
    padding: 0 28px;
    line-height: 1.2;
  }

  .corner__rank {
    display: block;
    font-size: 11px;
    letter-spacing: 1px;
  }

  .corner__credits {
    display: block;
    font-size: 13px;
  }

  .corner__white {
    color: #fff;
  }

  .corner__name {
    display: block;
    overflow: hidden;
    font-size: 16px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .corner__shop {
    position: absolute;
    top: 158px;
    left: 34px;
    /* Its own padding, and no width/height, for the same reason as the buttons above. */
    padding: 16px 26px;
    font-size: 12px;
    /* 2199ms is 2*pi*350ms — the period of the original's colour-cycle timer, not a round
       number to be tidied up. */
    animation: wis-hue 2199ms linear infinite;
  }

  .corner__loadout {
    position: absolute;
    top: 163px;
    left: 153px;
  }

  .corner__logout {
    position: absolute;
    top: 210px;
    left: 88px;
  }

  /*
   * Stops are max(sin(theta), 0)*255 per channel at 120-degree offsets, sampled every 30
   * degrees — not a hand-picked hue wheel. Three sines 120 degrees apart can never peak
   * together, so the co-peak ceiling is sin(30deg)*255 = 127: no saturated yellow/cyan/magenta,
   * only the dark red->purple->blue->teal->green->olive rotation these values trace.
   */
  @keyframes wis-hue {
    0% {
      color: rgb(0, 221, 0);
    }
    8.33% {
      color: rgb(127, 127, 0);
    }
    16.67% {
      color: rgb(221, 0, 0);
    }
    25% {
      color: rgb(255, 0, 0);
    }
    33.33% {
      color: rgb(221, 0, 0);
    }
    41.67% {
      color: rgb(127, 0, 127);
    }
    50% {
      color: rgb(0, 0, 221);
    }
    58.33% {
      color: rgb(0, 0, 255);
    }
    66.67% {
      color: rgb(0, 0, 221);
    }
    75% {
      color: rgb(0, 127, 127);
    }
    83.33% {
      color: rgb(0, 221, 0);
    }
    91.67% {
      color: rgb(0, 255, 0);
    }
    100% {
      color: rgb(0, 221, 0);
    }
  }
</style>
